export const TEST_ID = 'aircraftList';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const FLIGHT_CONTROLLER_SERIAL_COLUMN_KEY = 'flightControllerSerial';

export const MAKE_COLUMN_KEY = 'make';

export const MODEL_COLUMN_KEY = 'model';

export const NAME_COLUMN_KEY = 'nickname';

export const REGISTRATION_NUMBER_COLUMN_KEY = 'registrationNumber';

export const SERIAL_NUMBER_COLUMN_KEY = 'serialNumber';

export const SWATH_WIDTH_COLUMN_KEY = 'defaultSwathWidthMeters';

export const EMPTY_CELL_TEXT = '—';
